<script>
import {onBeforeUnmount, onMounted, ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
import router from "@/router";

export default {
  name: "W_PreviewChats",
  components: {LoadingPage},
  setup() {
    let store = ref(useStore())

    let loading = ref(false)

    let chats = ref([])

    let state_id = ref(null)
    let country = ref(FreeWorld.PinkMan(store.value.state.country, 'de'))

    function get_chats(load) {
      if (load) loading.value = true

      FreeWorld.Heisenberg({action: 'preview_chat'}, 'worker/my_chats', true).then((res) => {
        loading.value = false

        chats.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, () => {
          get_chats(load)
        })
      })
    }

    get_chats(true)

    function delete_chat(item) {
      Swals.Question('آیا از خذف این چت اطمینان دارید؟', 'حذف').then((res) => {

        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({
            action: 'delete_preview_chat',
            type: item.type,
            chats_id: item.id
          }, 'worker/my_chats', true).then((res) => {

            if (res.data.status === 'ok') {
              get_chats(true)
              Swals.Done('چت مورد نظر شما با موفقیت حذف شد')
            } else {
              loading.value = false
              Swals.Fault('متاسفانه چت مورد نظر شما حذف نشد!')
            }
          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              delete_chat(item)
            })
          })

        }

      })
    }

    function open_chat(item) {
      store.value.commit('set_chat', {name: item.chat_info, pic:item.pic})
      router.push({name: 'W_ChatsWorker', params: {chat_id: item.id}})
    }

    function block_chat(item) {
      Swals.Question('آیا از مسدود سازی این چت اطمینان دارید؟', 'مسدود').then((res) => {

        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({
            action: 'delete_preview_chat',
            type: item.type,
            chats_id: item.id
          }, 'user_chats', true).then((res) => {

            if (res.data.status === 'ok') {
              get_chats(true)
              Swals.Done('چت مورد نظر شما با موفقیت مسدود شد')
            } else {
              loading.value = false
              Swals.Fault('متاسفانه چت مورد نظر شما مسدود نشد!')
            }
          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              block_chat(item)
            })
          })

        }

      })
    }
    function report_chat() {
      Swals.Question('چت را گزارش میدهید؟' , 'گزارش دادن').then((res)=>{
        if (res.isConfirmed){
          loading.value = true

          setTimeout(()=>{
            loading.value = false
            Swals.Done('گزارش شما ثبت شد')
          },1000)
        }
      })
    }

    let interval_chats = null

    onMounted(() => {
      interval_chats = setInterval(() => {
        get_chats(false)
      }, 10000)
    })

    onBeforeUnmount(() => {
      clearInterval(interval_chats)
    })

    return {
      loading,
      chats,
      delete_chat,
      state_id,
      country,
      open_chat,
      store,
      report_chat,
      block_chat,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">پیام ها</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-if="chats.length === 0" style="height: 70vh"
           class="animate__animated animate__fadeIn w-100 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>


      <div v-else v-for="item in chats" :key="item.id"
           class="animate__animated animate__fadeIn p-3 rounded-pill bg-custom d-flex justify-content-between align-items-center shadow mb-3">
        <div @click="open_chat(item)" class="d-flex text-decoration-none align-items-center w-90">
          <div class="profile animated-background">
            <img class="profile" :src="item.pic" alt="">
          </div>

          <p class="font-5 text-color font-bold me-2">{{ item.chat_info }}</p>
        </div>

        <div class="d-flex align-items-center">
          <img @click="report_chat" class="icon-size-2 position-relative z-2" src="../assets/img/icon-block-user.svg" alt="">
          <img @click="delete_chat(item)" class="icon-size-1 mx-2 position-relative z-2" src="../assets/img/icon-binColor.svg" alt="">
          <img @click="block_chat(item)" class="icon-size-2 position-relative z-2" src="../assets/img/block_icon.png" alt="">
        </div>
      </div>

    </div>
  </div>

</template>

<style scoped>
.profile {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
</style>